/* global axios */
// NOTICE: KAPTION-INTEGRATION
import ApiClient from './ApiClient';

class KaptionConversationSearchAPI extends ApiClient {
  constructor() {
    super('kaption_conversation_search', { accountScoped: true });
  }

  search({ q, cursor, limit = 20 }) {
    return axios.get(this.url, {
      params: {
        q,
        cursor,
        limit,
      },
    });
  }
}

export default new KaptionConversationSearchAPI();
